const BASE = "/medical-coding/icd10-codes/search";

/** Resolve the medical-coding ICD-10 (CMS) search endpoint. */
export const icd10SearchPath = ({ nested }: { nested: boolean }): string =>
  nested ? `${BASE}/cms-nested-icd10cm/` : `${BASE}/cms-icd10cm/`;
